import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  reRenderMenu: false,
  userId: null,
  collapsedMenuMobile: false,
  showDetailsModuleReview: false,
  titleDetailTeamMonitoringOnBoarding: "",
  loadingTitleDetailTeamMonitoringOnBoarding: false,
};

export const localizationSlice = createSlice({
  name: "localization",
  initialState,
  reducers: {
    setReRenderMenu: (state, action) => {
      state.reRenderMenu = action.payload;
    },
    setUserIdLan: (state, action) => {
      state.userId = action.payload;
    },
    setCollapsedMenuMobile: (state, action) => {
      state.collapsedMenuMobile = action.payload;
    },
    setShowDetailsModuleReview: (state, action) => {
      state.showDetailsModuleReview = action.payload;
    },
    setTitleDetailTeamMonitoringOnBoarding: (state, action) => {
      state.titleDetailTeamMonitoringOnBoarding = action.payload;
    },
    setLoadingTitleDetailTeamMonitoringOnBoarding: (state, action) => {
      state.loadingTitleDetailTeamMonitoringOnBoarding = action.payload;
    }
  },
});

// Action creators are generated for each case reducer function
export const {
  setReRenderMenu,
  setUserIdLan,
  setCollapsedMenuMobile,
  setShowDetailsModuleReview,
  setTitleDetailTeamMonitoringOnBoarding,
  setLoadingTitleDetailTeamMonitoringOnBoarding,
} = localizationSlice.actions;

export default localizationSlice.reducer;
